import getPathToBecomeAdjacentToPosition from './getPathToBecomeAdjacentToPosition.js';
function getReachablePathToPosition(agentUnit, movementPoints, targetPosition, hexProperties, rules, allUnits, mapHexes) {
    if (hexProperties.getDistance(agentUnit.position, targetPosition) > movementPoints + 1) {
        return null;
    }
    return getPathToBecomeAdjacentToPosition(agentUnit, movementPoints, targetPosition, hexProperties, rules, allUnits, mapHexes);
}
export default getReachablePathToPosition;
